import script from "./textarea.vue?vue&type=script&setup=true&lang=js"
export * from "./textarea.vue?vue&type=script&setup=true&lang=js"

import "./textarea.vue?vue&type=style&index=0&id=1f67a1d3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f67a1d3"]])

export default __exports__